type Props = {
  amount: number | null;
  currency?: string;
};

export const CurrencyValue = ({ amount, currency }: Props) => {
  if (amount === null) {
    return <i>-</i>;
  }
  if (currency) {
    return (
      <i>
        {amount.toFixed(2)} {currency}
      </i>
    );
  }
  return <i>{amount.toFixed(2)}</i>;
};
